import request from '@ps/utils/request'

export function list(data) {
  return request({
    url:
      '/ps/setting/list?page_size=' +
      data.page_size +
      '&type=' +
      data.type +
      '&page=' +
      data.page,
    method: 'get',
  })
}

export function del(data) {
  return request({
    url: '/ps/setting/delete?id=' + data.id,
    method: 'post',
  })
}

export function create(data) {
  return request({
    url: '/ps/setting/create',
    method: 'post',
    data: data,
  })
}

export function info(data) {
  return request({
    url: '/ps/setting/info',
    method: 'get',
    data: data,
  })
}
